import { render, staticRenderFns } from "./high-end-talents.vue?vue&type=template&id=548247c3&scoped=true"
var script = {}
import style0 from "./high-end-talents.vue?vue&type=style&index=0&id=548247c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548247c3",
  null
  
)

export default component.exports